import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "card-header" }
const _hoisted_3 = { class: "card-title" }
const _hoisted_4 = { class: "card-toolbar" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa-solid fa-plus fa-xl",
  style: {"color":"#ffffff"}
}, null, -1)
const _hoisted_6 = { class: "card-body" }
const _hoisted_7 = {
  class: "table align-middle table-row-dashed fs-6 gy-5",
  id: "table_accounts_requests"
}
const _hoisted_8 = { class: "text-start text-muted fw-bold fs-7 text-uppercase gs-0" }
const _hoisted_9 = { class: "" }
const _hoisted_10 = { class: "" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "" }
const _hoisted_13 = { class: "" }
const _hoisted_14 = { class: "" }
const _hoisted_15 = { class: "text-center" }
const _hoisted_16 = { class: "text-center" }
const _hoisted_17 = { class: "cell-color text-center" }
const _hoisted_18 = { key: 0 }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = {
  key: 2,
  class: "fw-semibold"
}
const _hoisted_21 = { class: "" }
const _hoisted_22 = { class: "" }
const _hoisted_23 = { class: "" }
const _hoisted_24 = { class: "" }
const _hoisted_25 = { class: "" }
const _hoisted_26 = { class: "text-center" }
const _hoisted_27 = { class: "text-center" }
const _hoisted_28 = { class: "cell-color text-center" }

import { inject, onMounted, ref } from "vue";
import MsgPrompt from "@/core/plugins/MsgPrompt";
import PaymentService from "@/projects/tenant/modules/Payment/services/PaymentService";
import {
  PaymentPlatformTypes,
  PaymentStatusTypes,
} from "@/core/types/PaymentTypes";
import BalanceShow from "@/components/BalanceShow.vue";
import DepositReference from "@/projects/tenant/modules/Payment/modal/DepositReference.vue";
import UploadDepositReceiptModal from "@/projects/tenant/modules/Payment/modal/UploadDepositReceiptModal.vue";
import TenantGlobalInjectionKeys from "@/core/types/TenantGlobalInjectionKeys";
import { ActionType } from "@/core/types/Actions";
import { TransactionStateType } from "@/core/types/StateInfos";
import { ArrowDown } from "@element-plus/icons-vue";
import CreateDepositForAccount from "@/projects/tenant/modules/accounts/components/modal/CreateDepositForAccount.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AccountDetailDeposit',
  props: {
    accountDetails: {}
  },
  setup(__props: any) {

const props = __props;



const isLoading = ref(false);
const isSubmitting = ref(false);

const items = ref(Array<any>());
const depositReferenceRef = ref<InstanceType<typeof DepositReference>>();
const createDepositRef = ref<InstanceType<typeof CreateDepositForAccount>>();
const uploadDepositReceiptRef =
  ref<InstanceType<typeof UploadDepositReceiptModal>>();
const criteria = ref({
  page: 1,
  size: 10,
  accountId: props.accountDetails.id,
});

const openFilePreviewModal = inject<any>(
  TenantGlobalInjectionKeys.OPEN_FILE_MODAL
);

const openConfirmBox = inject(TenantGlobalInjectionKeys.OPEN_CONFIRM_MODAL);
const fetchData = async (_page) => {
  criteria.value.page = _page;
  isLoading.value = true;
  try {
    const res = await PaymentService.queryDeposits(criteria.value);
    items.value = res.data;
    criteria.value = res.criteria;
  } catch (e) {
    MsgPrompt.error(e);
  } finally {
    isLoading.value = false;
  }
};

const viewWireReceipt = async (id) => {
  const res = await PaymentService.getDepositReceiptById(id);
  const media = {
    guid: res[0],
  };
  openFilePreviewModal?.(media);
};

const viewPoliReference = async (id) => {
  const res = await PaymentService.getDepositReferenceById(id);
  depositReferenceRef.value?.show(res);
};

const openUploadDepositReceiptPanel = (id) => {
  uploadDepositReceiptRef.value?.show(id);
};

const openCreateDepositPanel = () => {
  createDepositRef.value?.show();
};

const openConfirmPanel = (
  _action: ActionType,
  id: number,
  paymentId?: number
) => {
  const _handler = {
    [ActionType.Approve]: () => PaymentService.approveDepositById(id),
    [ActionType.Reject]: () => PaymentService.rejectDepositById(id),
    [ActionType.Cancel]: () => PaymentService.cancelDepositById(id),
    [ActionType.CompletePayment]: async () => {
      if (!paymentId) {
        MsgPrompt.error("No PaymentId specified");
        return;
      }
      await PaymentService.completePaymentById(paymentId);
      await PaymentService.completeDepositByPaymentId(id);
    },
    [ActionType.Complete]: () => PaymentService.completeDepositByPaymentId(id),
  }[_action];
  if (!_handler) {
    MsgPrompt.error("No handler, action not supported");
    return;
  }
  openConfirmBox?.(
    () =>
      _handler()
        .then(() => MsgPrompt.success())
        .then(() => fetchData(criteria.value.page)),
    void 0,
    {
      confirmColor: _action === ActionType.Reject ? "danger" : "primary",
    }
  );
};

onMounted(() => {
  fetchData(1);
});

return (_ctx: any,_cache: any) => {
  const _component_LoadingRing = _resolveComponent("LoadingRing")!
  const _component_NoDataBox = _resolveComponent("NoDataBox")!
  const _component_TimeShow = _resolveComponent("TimeShow")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_TableFooter = _resolveComponent("TableFooter")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t("title.accountDeposit")), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("button", {
            class: "btn btn-sm btn-success fs-6",
            onClick: openCreateDepositPanel
          }, [
            _hoisted_5,
            _createTextVNode(" " + _toDisplayString(_ctx.$t("action.createDeposit")), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("table", _hoisted_7, [
          _createElementVNode("thead", null, [
            _createElementVNode("tr", _hoisted_8, [
              _createElementVNode("th", _hoisted_9, _toDisplayString(_ctx.$t("fields.deposit") + " " + _ctx.$t("fields.status")), 1),
              _createElementVNode("th", _hoisted_10, _toDisplayString(_ctx.$t("fields.paymentStatus")), 1),
              _createElementVNode("th", _hoisted_11, _toDisplayString(_ctx.$t("fields.paymentId")), 1),
              _createElementVNode("th", _hoisted_12, _toDisplayString(_ctx.$t("title.paymentMethod")), 1),
              _createElementVNode("th", _hoisted_13, _toDisplayString(_ctx.$t("fields.currency")), 1),
              _createElementVNode("th", _hoisted_14, _toDisplayString(_ctx.$t("fields.amount")), 1),
              _createElementVNode("th", _hoisted_15, _toDisplayString(_ctx.$t("fields.createdOn")), 1),
              _createElementVNode("th", _hoisted_16, _toDisplayString(_ctx.$t("fields.operatedBy")), 1),
              _createElementVNode("th", _hoisted_17, _toDisplayString(_ctx.$t("action.action")), 1)
            ])
          ]),
          (isLoading.value)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_18, [
                _createVNode(_component_LoadingRing)
              ]))
            : (!isLoading.value && items.value.length === 0)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_19, [
                  _createVNode(_component_NoDataBox)
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item, index) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: index,
                      class: _normalizeClass({
                'text-gray-400':
                  item.stateId === _unref(TransactionStateType).DepositCanceled,
              })
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.$t(`type.transactionState.${item.stateId}`).replace(
                    /^Deposit\s+/,
                    ""
                  )), 1),
                      _createElementVNode("td", _hoisted_21, [
                        _createElementVNode("span", {
                          class: _normalizeClass(["badge", {
                    'badge-primary':
                      item.payment.status === _unref(PaymentStatusTypes).Pending,
                    'badge-success':
                      item.payment.status === _unref(PaymentStatusTypes).Completed,
                    'badge-danger':
                      item.payment.status === _unref(PaymentStatusTypes).Rejected,
                    'badge-warning':
                      item.payment.status === _unref(PaymentStatusTypes).Executing,
                  }])
                        }, _toDisplayString(_ctx.$t(`type.paymentStatus.${item.payment.status}`)), 3)
                      ]),
                      _createElementVNode("td", _hoisted_22, _toDisplayString(item.payment.id), 1),
                      _createElementVNode("td", _hoisted_23, _toDisplayString(item.payment.paymentServiceName), 1),
                      _createElementVNode("td", _hoisted_24, _toDisplayString(_ctx.$t(`type.currency.${item.currencyId}`)), 1),
                      _createElementVNode("td", _hoisted_25, [
                        _createVNode(BalanceShow, {
                          "currency-id": item.currencyId,
                          balance: item.amount
                        }, null, 8, ["currency-id", "balance"])
                      ]),
                      _createElementVNode("td", _hoisted_26, [
                        _createVNode(_component_TimeShow, {
                          "date-iso-string": item.createdOn
                        }, null, 8, ["date-iso-string"])
                      ]),
                      _createElementVNode("td", _hoisted_27, _toDisplayString(item.operatorName), 1),
                      _createElementVNode("td", _hoisted_28, [
                        _createVNode(_component_el_dropdown, { trigger: "click" }, {
                          dropdown: _withCtx(() => [
                            _createVNode(_component_el_dropdown_menu, null, {
                              default: _withCtx(() => [
                                (
                          [
                            _unref(PaymentPlatformTypes).WireDeposit,
                            _unref(PaymentPlatformTypes).WholeSaleWireDeposit,
                          ].includes(item.payment.paymentServiceId)
                        )
                                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                      (item.hasReceipt)
                                        ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                            key: 0,
                                            onClick: ($event: any) => (viewWireReceipt(item.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("action.viewReceipt")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                        : (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                            key: 1,
                                            onClick: ($event: any) => (openUploadDepositReceiptPanel(item.id))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode(_toDisplayString(_ctx.$t("action.uploadReceipt")), 1)
                                            ]),
                                            _: 2
                                          }, 1032, ["onClick"]))
                                    ], 64))
                                  : (
                          _unref(PaymentPlatformTypes).Poli ==
                          item.payment.paymentServiceId
                        )
                                    ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                        key: 1,
                                        onClick: ($event: any) => (viewPoliReference(item.id))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(_ctx.$t("action.viewReference")), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["onClick"]))
                                    : _createCommentVNode("", true),
                                (
                          item.payment.status === _unref(PaymentStatusTypes).Executing
                        )
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 2,
                                      divided: "",
                                      onClick: ($event: any) => (
                          openConfirmPanel(
                            _unref(ActionType).CompletePayment,
                            item.id,
                            item.payment.id
                          )
                        )
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("action.completePayment")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (
                          item.stateId ===
                          _unref(TransactionStateType).DepositPaymentCompleted
                        )
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 3,
                                      divided: "",
                                      onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Approve, item.id))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("action.approve")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (
                          _ctx.$cans(['SuperAdmin']) &&
                          item.stateId ===
                            _unref(TransactionStateType).DepositPaymentCompleted
                        )
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 4,
                                      onClick: ($event: any) => (openConfirmPanel(_unref(ActionType).Reject, item.id))
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("action.reject")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true),
                                (
                          [
                            _unref(PaymentStatusTypes).Executing,
                            _unref(PaymentStatusTypes).Pending,
                          ].includes(item.payment.status)
                        )
                                  ? (_openBlock(), _createBlock(_component_el_dropdown_item, {
                                      key: 5,
                                      divided: "",
                                      onClick: ($event: any) => (
                          openConfirmPanel(
                            _unref(ActionType).Complete,
                            item.id,
                            item.payment.id
                          )
                        )
                                    }, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t("action.cancel")), 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          default: _withCtx(() => [
                            _createVNode(_component_el_button, {
                              type: "primary",
                              class: "btn btn-secondary btn-sm"
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t("action.action")), 1),
                                _createVNode(_component_el_icon, { class: "el-icon--right" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_unref(ArrowDown))
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            })
                          ]),
                          _: 2
                        }, 1024)
                      ])
                    ], 2))
                  }), 128))
                ]))
        ]),
        _createVNode(_component_TableFooter, {
          onPageChange: fetchData,
          criteria: criteria.value
        }, null, 8, ["criteria"])
      ])
    ]),
    _createVNode(DepositReference, {
      ref_key: "depositReferenceRef",
      ref: depositReferenceRef
    }, null, 512),
    _createVNode(CreateDepositForAccount, {
      ref_key: "createDepositRef",
      ref: createDepositRef,
      onFetchData: fetchData
    }, null, 512),
    _createVNode(UploadDepositReceiptModal, {
      ref_key: "uploadDepositReceiptRef",
      ref: uploadDepositReceiptRef,
      onFetchData: fetchData
    }, null, 512)
  ]))
}
}

})